import { toastr } from "react-redux-toastr";
import { Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import FormService from "Lib/API/Forms";
import CardImage from "assets/icons/EventInfoImg.png";
import { ContactUs } from "components/ContactUs/ContactUs";
import { useFormik } from "formik";
import * as calculation from "helper/Calculate";
import { checkIsStripe, checkIsTranzila } from "helper/checkIsStripe";
import { postalCodeFormat, postalCodeLabel } from "helper/postalCodeFormat";
import { useMobileView } from "hook/mobileView/useMobileView";
import { useSnackbar } from "notistack";
import { emailRegex } from "utils/validation";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { formSlice } from "services/api/forms";
import * as sharedFunctions from "../../Functions";
import Header from "./Header/Header";
import LoginModal from "./PersonalDetailsCard/LoginModal";
import { PaymentCard } from "./PaymentCard/PaymentCard";
import { PaymentResultPage } from "./PaymentResultPage/PaymentResultPage";
import { PersonalDetailsCard } from "./PersonalDetailsCard/PersonalDetailsCard";
import { SummaryCard } from "./SummaryCard/SummaryCard";
import {
  CardContent,
  ImageCard,
  ImageContainer,
  PaymentButtonSubmit,
  Wrapper
} from "./Theme";
import { Ticket } from "./Tickets/Ticket";
import {
  getAccessTokenSilently,
  getAuthenticated,
  logout
} from "utils/functions";
import AuthService from "Lib/API/Auth";
import DonationBox from "components/DonationBox/DonationBox";
import FinanceService from "Lib/API/Finance";
import { setLocalizationMoment } from "helper/dateFormat";
import { convenienceFeeAmount as calcConvenienceFee } from "helper/convenienceFee";

export const ReservationFormPage = () => {
  const isAuthenticated = getAuthenticated();
  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;

  const { enqueueSnackbar } = useSnackbar();
  const { isMobile } = useMobileView();
  const addCardStripeRef = useRef(null);
  const recaptchaRef = useRef();
  const formLoadedRef = useRef(false);
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const allowInstallmentsOrganization =
    localStorage.getItem("allowInstallments") === "true";

  const {
    formOnlineData,
    numberOfTickets,
    products,
    formDataOnlineform,
    totalProducts,
    varients
  } = useSelector(state => state?.Forms);

  const { logoImage } = useSelector(state => state.organization);

  const postalLabel = postalCodeLabel();

  const [isLoading, setLoading] = useState(false);
  const [isLoadingPay, setLoadingPay] = useState(false);
  const [error, setError] = useState({ value: true, message: "" });
  const [selectedCard, setSelectedCard] = useState(null);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [authTick, setAuthTick] = useState(0);
  const [newProducts, setProducts] = useState([]);
  const [selectedAchCard, setSelectedAchCard] = useState(null);
  const [ticketInstallment, setTicketInstallment] = useState({
    installmentStatus: false,
    installment: null
  });

  const [isCheckedApplay, setIsCheckedApplay] = useState(false);
  const logo = isAuth ? logoImage : localStorage.getItem("logoImgForm");
  const paymentMethod = JSON.parse(localStorage.getItem("paymentMethodForms"));
  const achPaymentMethod = JSON.parse(
    localStorage.getItem("achPaymentMethodForms")
  );

  const [convenienceFeeByPayment, setConvenienceFeeByPayment] = useState({
    "credit-card": true,
    ach: true
  });
  const [calcDueAmount, setCalcDueAmount] = useState(null);
  const token = localStorage.getItem("token");
  const formData = new FormData();
  const [firstRender, setFirstRender] = useState(false);
  const [checkoutDonationLedger, setCheckoutDonationLedger] = useState(null);
  const [donationAmount, setDonationAmount] = useState(0);
  const [isLoadingDonationLedger, setIsLoadingDonationLedger] = useState(true);
  const [donationError, setDonationError] = useState(false);
  const handleTotalForPay = () => {
    const totalforAllTicketsAfterDiscount = calculation.calculateTotalPayment(
      formOnlineData,
      numberOfTickets,
      "form",
      isAuth
    );
    return {
      total: (+totalforAllTicketsAfterDiscount + +totalProducts + +donationAmount).toFixed(2),
      totalcountTickets: (+totalPayforAllTickets).toFixed(2)
    };
  };
  const totalPay = handleTotalForPay();
  const makeFormScreen = totalPay?.total !== "0.00" || totalProducts > 0;

  const hasInstallmentOption = useCallback(() => {
    const prices = formOnlineData?.formPricing?.prices;
    const hasInstallmentInProducts = newProducts.some(
      product => product?.installmentStatus
    );
    const hasInstallmentInTicketVariants = prices?.some(
      item => item?.type === "onRegistration" && item?.installmentStatus
    );

    return hasInstallmentInProducts || hasInstallmentInTicketVariants;
  }, [newProducts, formOnlineData]);
  const hasInstallment = hasInstallmentOption();

  const enableCreditCardPay = paymentMethod?.allow_member || !isAuth;
  const enableAchPay =
    achPaymentMethod?.allow_member && checkIsStripe(achPaymentMethod);
  const disabledCreditCardPay =
    (hasInstallment && !paymentMethod?.allowMemberInstallment && isAuth) || donationError;
  const disabledAchPay =
    (hasInstallment && !achPaymentMethod?.allowMemberInstallment) ||
    (enableAchPay && !isAuth) || donationError;
  const displayAchTooltip = useMemo(
    () => (enableAchPay && !isAuth ? "Please login to pay with ACH" : ""),
    [enableAchPay, isAuth]
  );
  const enableBillMyAccount = formOnlineData?.allowBillMyAccount || false;
  const hasSelectedRecurring = useMemo(() => {
    const prices = formOnlineData?.formPricing?.prices || [];
    return newProducts.some(product => {
      if (!(product?.total > 0)) return false;
      const price = prices.find(p => p._id === product?.priceId);
      return price?.isRecurring;
    });
  }, [formOnlineData, newProducts]);

  const disabledBillMyAccount = useMemo(() => hasInstallment || hasSelectedRecurring, [hasInstallment, hasSelectedRecurring]);

  const isInstallmentEnabled = useMemo(() => {
    if (!allowInstallmentsOrganization) {
      return false;
    }

    return isAuth
      ? paymentMethod?.allowMemberInstallment ||
          achPaymentMethod?.allowMemberInstallment
      : true;
  }, [allowInstallmentsOrganization, isAuth, paymentMethod, achPaymentMethod]);

  const initialActivePayment = useMemo(() => {
    if (isAuth) {
      if (enableCreditCardPay) return "credit-card";
      if (enableAchPay) return "ach";
      if (formOnlineData?.allowBillMyAccount) return "bill-my-account";
      return "";
    }
    return "credit-card";
  }, [isAuth, enableCreditCardPay, enableAchPay, formOnlineData]);

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {
      registrationForm: [],
      errors: [],
      ticketsData: Array.from({ length: numberOfTickets?.length }, () => [
        ...products
      ]),
      dropdowns: [],
      accountInfo: {},
      cardsDetails: {},
      resultPage: "",
      activePayment: initialActivePayment
    },
    validationSchema: false,
    onSubmit: async values => {}
  });
  const activePayment = formik?.values?.activePayment;
  const hasNullOrUndefinedPrice = formik.values?.registrationForm[0]?.products?.some(
    item => {
      // Iterate over the inner objects (like "Pants", "Shirt", etc.)
      return Object.values(item).some(innerItem => {
        // Check if the inner object has a price property and if its value is null, undefined, or 0
        return (
          innerItem.price === null ||
          innerItem.price === undefined ||
          innerItem.price === 0
        );
      });
    }
  );

  const resetInstallment = () => {
    if (
      formOnlineData?.formPricing?.prices === undefined ||
      !formOnlineData?.formPricing?.prices?.length
    )
      return;
    const updatedFormPricing = formOnlineData?.formPricing?.prices?.map(
      item => {
        return {
          ...item,
          installmentStatus: false,
          installment: null
        };
      }
    );
    const updatedFormDetails = {
      ...formOnlineData,
      formPricing: {
        ...formOnlineData?.formPricing,
        prices: updatedFormPricing
      }
    };
    dispatch(formSlice.actions.setFormOnlineData(updatedFormDetails));
  };

  useEffect(() => {
    if (!firstRender && numberOfTickets.length > 0) {
      formik.setFieldValue(
        "ticketsData",
        Array.from({ length: numberOfTickets?.length }, () => [...products])
      );
      setFirstRender(true);
    }
    resetInstallment();
  }, [numberOfTickets]);
  const formDataReservation = formik?.values?.registrationForm || [];

  const totalPayforAllTickets = useMemo(
    () => formOnlineData?.formPricing?.total_to_pay * numberOfTickets.length,
    [formOnlineData, numberOfTickets]
  );

  const totalAmountCalculation = calculation?.calculateDiscount(
    formOnlineData,
    numberOfTickets,
    "form",
    isAuth
  );

  const totalPayment = useMemo(
    () => totalAmountCalculation?.totalAfterDiscount?.replace(/,/g, ""),
    [formOnlineData, numberOfTickets]
  );

  const totalDiscount = totalAmountCalculation?.totalDiscount;

  const thereIsFormEmpty = useMemo(
    () => formDataReservation?.some(item => item?.formData?.length === 0),
    [formDataReservation]
  );

  // True when all required registration-form fields have values.
  // Used to keep the Tranzila payment overlay active until the form is ready.
  const isRegistrationFormValid = useMemo(() => {
    if (thereIsFormEmpty) return false;
    const requiredFields = formDataOnlineform || [];
    for (const item of formik?.values?.registrationForm || []) {
      for (const subItem of item?.formData || []) {
        const required = requiredFields.find(
          (r) => r.id === subItem.id && r.required,
        );
        if (!required) continue;
        if (!subItem.value || subItem?.value?.length === 0) return false;
        if (subItem?.name?.includes("email_input")) {
          if (!emailRegex.test(subItem.value)) return false;
        }
      }
    }
    return true;
  }, [thereIsFormEmpty, formik?.values?.registrationForm, formDataOnlineform]);

  const getFormById = async () => {
    // restore selected deropDown List
    dispatch(formSlice.actions.resetAction([]));
    //  Get data for the first time (without any update on varients) when page loads
    dispatch(
      formSlice.actions.setVarients(
        JSON.parse(localStorage.getItem("originVarients"))
      )
    );
    try {
      setLoading(true);
      const token = isAuth
        ? await getAccessTokenSilently()
        : localStorage.getItem("formToken");
      const res = await FormService.getFormById(
        token,
        formOnlineData?.form,
        localStorage.getItem("formOrgId")
      );
      dispatch(formSlice.actions.setFormReservationData(res?.task_data));
    } catch (error) {
      enqueueSnackbar(error?.data?.message, {
        variant: "error"
      });
      dispatch(formSlice.actions.setFormReservationData({}));
    } finally {
      setLoading(false);
    }
  };

  const fetchFormDataIfNeeded = async () => {
    const hasFormData =
      formOnlineData && Object.keys(formOnlineData).length > 0;
    if (hasFormData) return;

    try {
      setLoading(true);
      const subDomain = window.location.hostname.split(".")[0];
      const hostName = subDomain === "localhost" ? (process.env.REACT_APP_LOCAL_ORGKEY || "stagerms") : subDomain;
      const auth = await AuthService.generateToken(hostName);
      localStorage.setItem("formToken", auth?.token);
      localStorage.setItem("logoImgForm", auth?.logoImg);
      localStorage.setItem("formOrgId", auth?._id);
      localStorage.setItem("email", auth?.contactInfo?.email);
      localStorage.setItem("phone", auth?.contactInfo?.phone);
      localStorage.setItem("orgName", auth?.orgName);
      document.title = `${auth?.orgName}`;
      localStorage.setItem(
        "paymentMethodForms",
        JSON.stringify(auth?.paymentMethodCreditCard)
      );
      localStorage.setItem(
        "achPaymentMethodForms",
        JSON.stringify(auth?.paymentMethodAch)
      );
      localStorage.setItem("country", JSON.stringify(auth?.country || {}));
      localStorage.setItem("shul_website", auth?.shul_website || "");
      localStorage.setItem("memberPortal", auth?.memberPortal || false);
      localStorage.setItem(
        "allowInstallments",
        auth?.allowInstallments || false
      );

      setLocalizationMoment(auth?.country?.local || "en");

      const token = isAuth ? await getAccessTokenSilently() : auth?.token;
      await FormService.getOnlineFormsById(token, params?.id).then(res => {
        dispatch(formSlice.actions.setFormOnlineData(res?.result));
        if (res?.result?.formPricing?.prices.length > 0) {
          const products = res?.result?.formPricing?.prices?.filter(item => {
            if (
              item?.type === "optional" ||
              item?.type === "openAmount" ||
              (item?.type === "onRegistration" && item?.variant)
            ) {
              return item;
            }
          });
          const varients = [];
          let varientCapacity = 0;
          const productRest = products?.map(val => {
            if (val?.variant) {
              const variantsInfo =
                val?.variantInfo &&
                Object.keys(val?.variantInfo).map(key => {
                  if (val.variantInfo[key]?.infiniteQuantity) {
                    varientCapacity = Infinity;
                  } else {
                    varientCapacity += Number(val.variantInfo[key]?.quantity) || 0;
                  }
                  return {
                    option: key,
                    counterValue: 0,
                    selectedValue: "",
                    ...val.variantInfo[key]
                  };
                });
              varients.push({
                variantsInfo: variantsInfo,
                varientCapacity: varientCapacity === Infinity || isNaN(varientCapacity)
                  ? "noLimit"
                  : varientCapacity,
                numberOfDrops: 0,
                varientTitle: val.title,
                id: val._id,
                type: val?.type
              });
              varientCapacity = 0;
              return {
                ...val,
                variantInfo: variantsInfo,
                counter: 0,
                dropdowns: []
              };
            } else {
              varients.push({
                numberOfDrops: 0,
                quantity: 0,
                varientCapacity: !val.infiniteQuantity
                  ? Number(val.quantity)
                  : "noLimit",
                counterValue: 0,
                variantsInfo: [],
                varientTitle: val.title,
                id: val._id,
                amount: val.amount,
                type: val?.type
              });
              return { ...val, counter: 0, dropdowns: [] };
            }
          });
          localStorage.setItem(
            "originVarients",
            JSON.stringify({ ...varients })
          );
          dispatch(formSlice.actions.setVarients({ ...varients }));
          dispatch(formSlice.actions.resetAction([]));
          dispatch(formSlice.actions.setProducts(productRest));
        }
      });
    } catch (error) {
      enqueueSnackbar(error?.data?.message || "Failed to load form data", {
        variant: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    localStorage.removeItem("redirectUrl");
    return () => {
      localStorage.setItem("registrationForm", []);
      localStorage.setItem("ApplayCheckBox", JSON.stringify(false));
    };
  }, []);

  useEffect(() => {
    const fetchCheckoutDonationLedger = async () => {
      try {
        const orgToken = isAuth
          ? await getAccessTokenSilently()
          : localStorage.getItem("formToken");
        const orgId = localStorage.getItem("formOrgId");
        const res = await FinanceService.getCheckoutDonationLedger(orgToken, orgId);
        if (res?.ledger) setCheckoutDonationLedger(res.ledger);
      } catch (_) {} finally {
        setIsLoadingDonationLedger(false);
      }
    };
    fetchCheckoutDonationLedger();
  }, []);

  useEffect(() => {
    fetchFormDataIfNeeded();
  }, []);

  const getCurrentPaymentMethod = useCallback(() => {
    if (formik?.values?.activePayment === "credit-card") {
      return paymentMethod;
    }
    if (formik?.values?.activePayment === "ach") {
      return achPaymentMethod;
    }
    return null;
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const currentPaymentMethod = useMemo(() => getCurrentPaymentMethod(), [
    getCurrentPaymentMethod
  ]);
  const isStripe = useMemo(() => checkIsStripe(currentPaymentMethod), [
    currentPaymentMethod
  ]);
  const isTranzila = useMemo(() => checkIsTranzila(currentPaymentMethod), [
    currentPaymentMethod
  ]);

  const convenienceFee = useMemo(() => {
    if (!currentPaymentMethod) return 0;
    const shouldApplyConvenienceFee =
      currentPaymentMethod.coverConvenienceFee &&
      convenienceFeeByPayment[activePayment];

    if (!shouldApplyConvenienceFee) return 0;
    const baseForCF = totalPay?.total - donationAmount;
    return calcConvenienceFee(currentPaymentMethod?.convenienceFeeInfo, baseForCF);
  }, [totalPay, donationAmount, currentPaymentMethod, convenienceFeeByPayment, activePayment]);

  const totalPaymentWithCVFee =
    formik?.values?.activePayment === "bill-my-account"
      ? totalPay?.total
      : +totalPay?.total + +convenienceFee;

  const dueAmountConvenienceFee = useCallback(
    totalDueAmount => {
      if (!currentPaymentMethod) return 0;
      const shouldApplyConvenienceFee =
        currentPaymentMethod.coverConvenienceFee &&
        convenienceFeeByPayment[activePayment];

      if (!shouldApplyConvenienceFee) return 0;
      return calcConvenienceFee(
        currentPaymentMethod?.convenienceFeeInfo,
        totalDueAmount,
      );
    },
    [currentPaymentMethod, convenienceFeeByPayment, activePayment]
  );

  const calculateAmountProducts = (items, type = "ticket") => {
    return items.reduce((total, item) => {
      // Skip variant products - they're already counted in variantAmount
      if (item?.variantsInfo || item?.type === "variant") return total;
      const installmentValue =
        item?.installmentStatus && item?.installment?.value;
      const itemAmount =
        type === "ticket"
          ? item?.amount * item?.selectedQuantity
          : item?.amount;
      return (
        total + (installmentValue ? itemAmount / installmentValue : itemAmount)
      );
    }, 0);
  };

  const calculateAmount = items => {
    return items?.reduce((sum, item) => {
      if (item?.type === "onRegistration") {
        // normal product
        if (!item.variant) {
          return sum + item.amount;
        }

        // 🔥 variant product
        if (item.variant) {
          const variantTotal = Object.values(item.variant || {}).reduce(
            (acc, v) => acc + (v.price || 0) * (v.quantity || 1),
            0
          );

          return sum + variantTotal;
        }
      }
      return sum;
    }, 0);
  };
  //   const calculateDueAmount = useCallback(() => {
  //     // const totalTicketAmount = calculateAmount(
  //     //   formOnlineData?.formPricing?.prices,
  //     // );
  //     const totalTicketAmount = Object.values(varients || {}).reduce(
  //   (sum, product) => {
  //     if (product?.variantsInfo?.length) {
  //       const variantTotal = product.variantsInfo.reduce(
  //         (acc, v) => acc + (v.counterValue * (v.price || v.amount || 0)),
  //         0
  //       );
  //       return sum + variantTotal;
  //     }

  //     // non-variant
  //     return sum + (product.counterValue * (product.price || product.amount || 0));
  //   },
  //   0
  // );
  //     const totalProductAmount = calculateAmountProducts(newProducts, "product");
  //     const {
  //       totalAfterDiscount,
  //       discountTotal,
  //     } = calculation.calculateDueDiscount(
  //       totalTicketAmount,
  //       formOnlineData?.formDiscount,
  //       numberOfTickets,
  //       isAuth,
  //     );
  //     const totalDueAmount = +totalProductAmount + +totalAfterDiscount;
  //     const convenienceFeeAmount = dueAmountConvenienceFee(totalDueAmount);
  //     return {
  //       totalDueAmount,
  //       dueAmountCF: convenienceFeeAmount,
  //       totalDueAmountWithCF: totalDueAmount + convenienceFeeAmount,
  //       dueAmountTotalDiscount: discountTotal,
  //     };
  //   }, [newProducts, dueAmountConvenienceFee]);
  const calculateDueAmount = useCallback(() => {
    // ✅ 1. Base registration (500)
    const baseAmount = formOnlineData?.formPricing?.prices?.reduce(
      (sum, item) => {
        if (item.type === "onRegistration" && !item.variant) {
          return sum + (item.amount || 0);
        }
        return sum;
      },
      0
    );

    // ✅ 2. Variant amount (Seat Type etc)
    // const variantAmount = Object.values(varients || {}).reduce(
    //   (sum, product, productIndex) => {

    //     // ✅ ONLY include ticket variants
    //     if (!product?.type || product.type !== "onRegistration") {
    //       return sum;
    //     }

    //     if (!product?.variantsInfo?.length) return sum;

    //     const variantAmount = Object.values(varients || {}).reduce(
    //   (sum, product) => {

    //     // ✅ only onRegistration variants
    //     if (product?.type !== "onRegistration") return sum;

    //     if (!product?.variantsInfo?.length) return sum;

    //     const total = product.variantsInfo.reduce((acc, v) => {
    //       const price = v.price || v.amount || 0;
    //       const qty = v.counterValue || 0;

    //       return acc + price * qty;
    //     }, 0);

    //     return sum + total;
    //   },
    //   0
    // );
    //   },
    //   0
    // );
    const variantAmount = Object.values(varients || {}).reduce(
      (sum, product) => {
        // Variant products (with variantsInfo)
        if (product?.variantsInfo?.length) {
          const total = product.variantsInfo.reduce((acc, v) => {
            const price =
              v.price !== undefined && v.price !== null
                ? v.price
                : v.amount || 0;
            const qty = v.counterValue || 0;
            return acc + price * qty;
          }, 0);
          return sum + total;
        }
        // Non-variant products (optional products like Course Books)
        if (
          !product?.variantsInfo?.length &&
          product?.type !== "onRegistration"
        ) {
          const price = product.price || product.amount || 0;
          const priceInfo = formOnlineData?.formPricing?.prices?.find(p => p._id === product.id);
          const minQty = priceInfo?.isRequired ? (priceInfo?.minimumQuantity || 1) : 0;
          const qty = Math.max(product.counterValue || 0, minQty);
          return sum + price * qty;
        }
        return sum;
      },
      0
    );
    const totalTicketAmount = baseAmount + variantAmount;

    // ✅ 3. Addons - now handled in variantAmount for non-variant products
    const totalProductAmount = 0;
    console.log(
      "tanya6",
      baseAmount,
      variantAmount,
      totalTicketAmount,
      totalProductAmount
    );
    const {
      totalAfterDiscount,
      discountTotal
    } = calculation.calculateDueDiscount(
      totalTicketAmount,
      formOnlineData?.formDiscount,
      numberOfTickets,
      isAuth
    );

    // Calculate installment amounts for Due Now
    const installmentPrices = formOnlineData?.formPricing?.prices || [];

    // Get installment info from both formOnlineData (for onRegistration) and newProducts (for optional)
    const getInstallmentInfo = (priceId, title) => {
      const priceItem = installmentPrices.find(p => p._id === priceId);
      if (priceItem?.installmentStatus && priceItem?.installment?.value) {
        return {
          installmentStatus: true,
          installmentValue: priceItem.installment.value
        };
      }
      const product = newProducts?.find(
        p => p.priceId === priceId || p.title === title
      );
      if (product?.installmentStatus && product?.installment?.value) {
        return {
          installmentStatus: true,
          installmentValue: product.installment.value
        };
      }
      return { installmentStatus: false, installmentValue: null };
    };

    const calculateWithInstallment = (installmentInfo, amount) => {
      if (
        installmentInfo.installmentStatus &&
        installmentInfo.installmentValue
      ) {
        return amount / installmentInfo.installmentValue;
      }
      return amount;
    };

    // Calculate baseAmount with installments
    const baseAmountWithInstallments = formOnlineData?.formPricing?.prices?.reduce(
      (sum, item) => {
        if (
          item.type === "onRegistration" &&
          !item.variant &&
          item.amount > 0
        ) {
          const installmentInfo = getInstallmentInfo(item._id, item.title);
          return sum + calculateWithInstallment(installmentInfo, item.amount);
        }
        return sum;
      },
      0
    );

    // Calculate variant amount with installments
    const variantAmountWithInstallments = Object.values(varients || {}).reduce(
      (sum, product) => {
        const installmentInfo = getInstallmentInfo(
          product.id,
          product.varientTitle
        );

        if (product?.variantsInfo?.length) {
          const total = product.variantsInfo.reduce((acc, v) => {
            const price =
              v.price !== undefined && v.price !== null
                ? v.price
                : v.amount || 0;
            const qty = v.counterValue || 0;
            const itemTotal = price * qty;
            return acc + calculateWithInstallment(installmentInfo, itemTotal);
          }, 0);
          return sum + total;
        }
        // Non-variant products
        if (
          !product?.variantsInfo?.length &&
          product?.type !== "onRegistration"
        ) {
          const price = product.price || product.amount || 0;
          const qty = product.counterValue || 0;
          const itemTotal = price * qty;
          return sum + calculateWithInstallment(installmentInfo, itemTotal);
        }
        return sum;
      },
      0
    );

    const totalDueAmountWithInstallments =
      baseAmountWithInstallments + variantAmountWithInstallments;

    // Use installment amount if installments are selected, otherwise use full amount
    const hasAnyInstallmentInPrices = installmentPrices.some(
      p => p?.installmentStatus && p?.installment?.value
    );
    const hasAnyInstallmentInProducts = newProducts?.some(
      p => p?.installmentStatus && p?.installment?.value
    );
    const hasAnyInstallment =
      hasAnyInstallmentInPrices || hasAnyInstallmentInProducts;

    const totalDueAmount = hasAnyInstallment
      ? totalDueAmountWithInstallments
      : +totalProductAmount + +totalAfterDiscount;

    const convenienceFeeAmount = dueAmountConvenienceFee(totalDueAmount);
    console.log("tanya7", convenienceFeeAmount, totalDueAmount);
    return {
      totalDueAmount,
      dueAmountCF: convenienceFeeAmount,
      totalDueAmountWithCF: totalDueAmount + convenienceFeeAmount,
      dueAmountTotalDiscount: discountTotal
    };
  }, [
    varients,
    formik.values.ticketsData,
    newProducts,
    formOnlineData,
    convenienceFeeByPayment,
    activePayment
  ]);
  const updatedFormDataWithDatePicker = formDataItem => {
    let formDataArray = [];
    formDataItem.forEach(item => {
      if (item?.name?.includes("date_picker")) {
        const datePickerField = document.querySelector(`[name="${item.name}"]`);
        formDataArray.push({
          ...item,
          value: datePickerField.value || null
        });
      } else {
        formDataArray.push(item);
      }
    });
    return formDataArray;
  };

  const updatedProductsData = products => {
    return products.map(product => {
      const varientEntry = Object.values(varients || {}).find(
        v => v?.id === product?.id,
      );

      const isAddon = !!varientEntry;

      let updatedVariant = product.variant;
      if (product.variant && typeof product.variant === "object") {
        updatedVariant = Object.fromEntries(
          Object.entries(product.variant).map(([key, val]) => {
            const variantOption = varientEntry?.variantsInfo?.find(
              vi => vi.option === key,
            );
            if (variantOption?.openAmount) return [key, val];
            if (isAddon) return [key, variantOption?.counterValue ?? val?.quantity ?? val];
            const { price: _price, ...rest } = val || {};
            return [key, rest];
          }),
        );
      }

      const result = { ...product, variant: updatedVariant };

      const matchedNewProduct = (newProducts || []).find(p => p.priceId === product.id);
      const classPrice = formOnlineData?.formPricing?.prices?.find(p => p._id === product.id);
      const installmentValue =
        (matchedNewProduct?.installmentStatus && matchedNewProduct?.installment?.value)
          ? matchedNewProduct.installment.value
          : (classPrice?.installmentStatus && classPrice?.installment?.value)
            ? classPrice.installment.value
            : null;
      if (installmentValue) result.numberOfInstallments = installmentValue;

      return result;
    });
  };

  const installmentOnRegistrationPrices = () => {
    const prices = formOnlineData?.formPricing?.prices;
    const installmentPrices = prices
      ?.map(item => {
        if (item?.type === "onRegistration" && item?.installmentStatus) {
          return {
            priceId: item?._id,
            numberOfInstallment: item?.installment?.value
          };
        }
      })
      .filter(item => item !== undefined);
    return installmentPrices;
  };

  const ConvertFormToFormData = data => {
    const dataArray = [...data];
    if (dataArray[0] !== undefined) {
      // TODO: Replace map with forEach since there is nothing returned from the map
      const formDataArray = dataArray.map((dataItem, dataIndex) => {
        const { id, formData: formDataItem, products } = dataItem;
        const updatedFormData = updatedFormDataWithDatePicker(formDataItem);
        const updatedProducts = updatedProductsData(products);
        const installmentPrices = installmentOnRegistrationPrices();

        if (installmentPrices?.length > 0) {
          formData.append(
            `installments`,
            JSON.stringify([...installmentPrices])
          );
        }
        // ? Check if this is in use; if not, consider deleting it.
        formData.append(
          `registrationForm[${dataIndex}][formData]`,
          JSON.stringify([...updatedFormData])
        );
        formData.append(`registrationForm[${dataIndex}][id]`, `${id}`);
        formData.append(
          `registrationForm[${dataIndex}][products]`,
          JSON.stringify([...updatedProducts])
        );
        // ? Check if this is in use; if not, consider deleting it.
        const formDataObj = formDataItem?.forEach(dataItem => {
          if (dataItem?.name?.includes("file_upload")) {
            if (dataItem?.value && dataItem?.value !== null) {
              formData.append(
                `registrationForm[${dataIndex}][files][${id}]`,
                dataItem?.value
              );
            }
          }
        });
      });
    }
  };
  const handleDataForTwoFlow = (tokenId = "", coverFee = true, tranzilaChargeResult = null) => {
    formData.append(`isMember`, isAuth ? true : false);
    if (!isAuth) {
      formData.append(`orgId`, localStorage.getItem("formOrgId"));
    }
    formData.append(`formId`, params?.id);
    formData.append("coverFee", coverFee);
    if (donationAmount > 0 && checkoutDonationLedger) {
      formData.append("checkoutDonation[ledger_id]", checkoutDonationLedger._id || checkoutDonationLedger.ledger_id || "");
      formData.append("checkoutDonation[ledger_name]", checkoutDonationLedger.ledger_name || "");
      formData.append("checkoutDonation[amount]", donationAmount);
      if (checkoutDonationLedger.account_receivable) {
        formData.append("checkoutDonation[account_receivable]", checkoutDonationLedger.account_receivable);
      }
    }
    const objectName = "cardsDetails";
    const objectData = formik?.values?.cardsDetails;
    if (formik?.values?.activePayment === "credit-card") {
      formData.append("paymentMethodId", paymentMethod?._id);
      if (isAuth) {
        formData.append("cardId", selectedCard);
      } else if (tranzilaChargeResult) {
        formData.append("tranzilaChargeResult", JSON.stringify(tranzilaChargeResult));
      } else if (tokenId) {
        formData.append("token", tokenId);
      } else {
        for (const key in objectData) {
          if (key === "expiry") {
            formData.append(
              `${objectName}[exp_month]`,
              objectData[key]?.split("/")[0]
            );
            formData.append(
              `${objectName}[exp_year]`,
              objectData[key]?.split("/")[1]
            );
          } else if (key === "card_number") {
            formData.append(`${objectName}[number]`, objectData[key]);
          } else {
            formData.append(`${objectName}[${key}]`, objectData[key]);
          }
        }
      }
    } else if (formik?.values?.activePayment === "ach") {
      formData.append("paymentMethodId", achPaymentMethod?._id);
      if (isAuth) {
        formData.append("cardId", selectedAchCard);
      }
    } else {
      formData.append(`billMyAccount`, true);
    }

    if (isAuth) return;
    // Account Info
    const objectName2 = "accountInfo";
    const objectData2 = formik?.values?.accountInfo;
    for (const key in objectData2) {
      if (key === "addresses") {
        const objeLocation = formik.values?.accountInfo?.addresses[0].location;
        if (Object.keys(objeLocation).length !== 0) {
          formik.values?.accountInfo?.addresses[0].location?.formattedAddress &&
            formData.append(
              `${objectName2}[addresses][0][location][formattedAddress]`,
              formik.values?.accountInfo?.addresses[0].location
                ?.formattedAddress
            );
          formik.values?.accountInfo?.addresses[0].location?.place_id &&
            formData.append(
              `${objectName2}[addresses][0][location][place_id]`,
              formik.values?.accountInfo?.addresses[0].location?.place_id
            );
          formik.values?.accountInfo?.addresses[0]?.city &&
            formData.append(
              `${objectName2}[addresses][0][city]`,
              formik.values?.accountInfo?.addresses[0]?.city
            );
          formik.values?.accountInfo?.addresses[0]?.state &&
            formData.append(
              `${objectName2}[addresses][0][state]`,
              formik.values?.accountInfo?.addresses[0]?.state
            );
          formik.values?.accountInfo?.addresses[0]?.zip_code &&
            formData.append(
              `${objectName2}[addresses][0][zip_code]`,
              formik.values?.accountInfo?.addresses[0]?.zip_code
            );
          formik.values?.accountInfo?.addresses[0]?.addressLine2 &&
            formData.append(
              `${objectName2}[addresses][0][addressLine2]`,
              formik.values?.accountInfo?.addresses[0]?.addressLine2
            );
        }
      } else {
        formData.append(`${objectName2}[${key}]`, objectData2[key]);
      }
    }
  };

  // get stripe token
  const handleGetStripeToken = async () => {
    const tokenId = await addCardStripeRef?.current?.handleGetToken();
    if (tokenId && tokenId !== null && token !== undefined) {
      return tokenId;
    }
    return "";
  };

  const isValidInstallment = () => {
    const prices = formOnlineData?.formPricing?.prices;

    let isValid = true;
    const products = newProducts.forEach(item => {
      if (item?.installmentStatus && !item?.installment?.value) {
        isValid = false;
      }
    });
    const tickets = prices?.forEach(item => {
      if (
        item?.type === "onRegistration" &&
        item?.installmentStatus &&
        !item?.installment?.value
      ) {
        isValid = false;
      }
    });
    return isValid;
  };

  // Api For Pay
  const handleTranzilaCharged = async (result) => {
    // Validate required registration fields before completing the registration.
    // The Tranzila iframe fires this callback after the card charge, so we must
    // check here to prevent a registration record being created with missing data.
    if (thereIsFormEmpty) {
      return enqueueSnackbar(
        "You have errors in filling out the form, please check them",
        { variant: "error" },
      );
    }
    const requiredFields = formDataOnlineform;
    const dataValidation = formik?.values?.registrationForm?.map((item, index) => ({
      ...item,
      formData: item?.formData
        ?.map((subItem, subItemIndex) => {
          const required = requiredFields?.find(
            (r) => r.id === subItem.id && r.required,
          );
          if (subItem?.name?.includes("date_picker") && required) {
            const el = document.querySelector(`[name="${subItem.name}"]`);
            return {
              errorMessage:
                !el?.value ? `The ${required?.label} is required` : "",
            };
          }
          if (subItem?.name?.includes("file_upload") && required) {
            return {
              errorMessage:
                !subItem.value?.name ? `The ${required?.label} is required` : "",
            };
          }
          if (subItem.value && subItem?.value?.length > 0) {
            if (subItem?.name?.includes("email_input")) {
              return {
                errorMessage: emailRegex.test(subItem.value)
                  ? ""
                  : `Please enter valid email for (${requiredFields[subItemIndex]?.label}) field`,
              };
            }
            return { errorMessage: "" };
          }
          if (required) {
            return { errorMessage: `The ${required.label} is required` };
          }
          return { errorMessage: "" };
        })
        .filter((e) => e.errorMessage !== ""),
    }));
    formik.setFieldValue("errors", dataValidation);
    const allErrorsEmpty = dataValidation.every(
      (item) => item.formData.length === 0,
    );
    if (!allErrorsEmpty) {
      return enqueueSnackbar(
        "You have errors in filling out the form, please check them",
        { variant: "error" },
      );
    }

    handleDataForTwoFlow("", true, result);
    ConvertFormToFormData(formDataReservation);
    setLoadingPay(true);
    try {
      const token = localStorage.getItem("formToken");
      await FormService.createOnlineFormParticipant(token, formData);
      formik.setFieldValue("resultPage", "success");
    } catch (err) {
      enqueueSnackbar(err?.data?.message || "Payment failed, please try again", { variant: "error" });
    } finally {
      setLoadingPay(false);
    }
  };

  const PayNow = async hasStripe => {
    const isFreeRegistration = totalPay?.total === "0.00" && totalProducts <= 0;
    if (!formik?.values?.activePayment && !isFreeRegistration) return;
    const captchaValue = recaptchaRef?.current?.getValue();
    if (
      !captchaValue &&
      !isAuth &&
      (totalPay?.total !== "0.00" || totalProducts > 0)
    )
      return enqueueSnackbar("Please verify the captcha", {
        variant: "info"
      });

    if (isLoadingPay) return;
    const thereIsFormEmpty = formDataReservation?.some(
      item => item?.formData?.length === 0
    );
    if (thereIsFormEmpty) {
      enqueueSnackbar(
        "You have errors in filling out the form , please check them",
        {
          variant: "error"
        }
      );
    } else {
      const requiredFields = formDataOnlineform;
      const dataValidation = formik?.values?.registrationForm?.map(
        (item, index) => {
          return {
            ...item,
            formData: item?.formData
              ?.map((subItem, subItemIndex) => {
                const requireds = requiredFields?.find(
                  tofinditem =>
                    tofinditem.id === subItem.id && tofinditem.required
                );
                if (
                  subItem?.name.includes("date_picker") &&
                  requireds !== undefined
                ) {
                  const datePickerField = document.querySelector(
                    `[name="${subItem.name}"]`
                  );
                  if (
                    !datePickerField.value ||
                    datePickerField.value === undefined
                  ) {
                    return {
                      errorMessage: `The ${requireds?.label} is required`
                    };
                  } else {
                    return { errorMessage: "" };
                  }
                }
                if (
                  subItem?.name.includes("file_upload") &&
                  requireds !== undefined
                ) {
                  if (
                    !subItem.value?.name ||
                    subItem.value?.name === undefined
                  ) {
                    return {
                      errorMessage: `The ${requireds?.label} is required`
                    };
                  } else {
                    return { errorMessage: "" };
                  }
                }
                if (subItem.value && subItem?.value?.length > 0) {
                  if (subItem?.name.includes("email_input")) {
                    return {
                      errorMessage: emailRegex.test(subItem.value)
                        ? ""
                        : `Please enter valid email for (${requiredFields[subItemIndex]?.label}) field`
                    };
                  }
                  if (subItem?.name.includes("phone_input")) {
                    const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                    return {
                      errorMessage: phoneRegex.test(subItem.value)
                        ? ""
                        : `Please enter valid Phone Number for (${requiredFields[subItemIndex]?.label}) field`
                    };
                  } else {
                    return { errorMessage: "" };
                  }
                }
                if (requireds !== undefined) {
                  return { errorMessage: `The ${requireds.label} is required` };
                } else {
                  return { errorMessage: "" };
                }
              })
              .filter(element => element.errorMessage !== "")
          };
        }
      );
      formik.setFieldValue("errors", dataValidation);
      const allErrorsEmpty = dataValidation.every(
        item => item.formData.length === 0
      );

      if (allErrorsEmpty) {
        const validInstallment = isValidInstallment();
        if (!validInstallment) {
          return enqueueSnackbar("Please select number of installments", {
            variant: "info"
          });
        }

        const validZipCode = postalCodeFormat(
          formik?.values?.cardsDetails?.zip
        );
        if (
          !isStripe &&
          formik?.values?.cardsDetails?.zip?.length &&
          !validZipCode &&
          formik?.values?.activePayment === "credit-card" &&
          !isAuth
        ) {
          enqueueSnackbar(`Invalid ${postalLabel}`, { variant: "info" });
        }
        let tokenId = "";
        if (
          isStripe &&
          formik?.values?.activePayment === "credit-card" &&
          !isAuth
        ) {
          tokenId = await handleGetStripeToken();
        }

        if (
          isAuth &&
          !selectedCard &&
          formik?.values?.activePayment === "credit-card" &&
          (totalPay?.total !== "0.00" || totalProducts > 0)
        ) {
          enqueueSnackbar("Please select a credit card", { variant: "error" });
          return;
        }

        if (
          isAuth &&
          !selectedAchCard &&
          formik?.values?.activePayment === "ach" &&
          (totalPay?.total !== "0.00" || totalProducts > 0)
        ) {
          enqueueSnackbar("Please select an ACH card", { variant: "error" });
          return;
        }

        if (
          (hasStripe && tokenId) ||
          !hasStripe ||
          formik?.values?.activePayment === "bill-my-account" ||
          (isAuth && selectedCard) ||
          (isAuth && selectedAchCard)
        ) {
          handleDataForTwoFlow(
            tokenId || "",
            convenienceFeeByPayment[activePayment]
          );
          ConvertFormToFormData(formDataReservation);
          if (error?.message) {
            enqueueSnackbar(error?.message, {
              variant: "error"
            });
            setLoadingPay(false);
          } else {
            setLoadingPay(true);
            const token = isAuth
              ? await getAccessTokenSilently()
              : localStorage.getItem("formToken");
            try {
              await FormService.createOnlineFormParticipant(
                token,
                formData
              ).then(res => {
                formik.setFieldValue("resultPage", "success");
              });
            } catch (error) {
              const message = error?.data?.message
                ? error?.data?.message
                : "There is something wrong";
              enqueueSnackbar(message, {
                variant: "error"
              });
            } finally {
              setLoadingPay(false);
            }
          }
        }
      } else {
        enqueueSnackbar(
          "You have errors in filling out the form , please check them",
          {
            variant: "error"
          }
        );
      }
    }
  };

  useEffect(() => {
    if (
      Object.keys(formOnlineData).length !== 0 &&
      !formOnlineData?.allowNonMembers &&
      !isAuthenticated
    ) {
      history.push(`/form/${params?.id}`);
    } else {
      if (isAuth) {
        setTimeout(() => {
          const accountDetails = JSON.parse(
            localStorage.getItem("accountInfo")
          );
          formik.setFieldValue("accountInfo", {
            first_name: accountDetails?.firstName ?? "",
            last_name: accountDetails?.lastName ?? "",
            primary_email_address: accountDetails?.primary_email_address ?? ""
          });
        }, 2000);
      }
      if (Object.keys(formOnlineData).length !== 0 && !formLoadedRef.current) {
        formLoadedRef.current = true;
        getFormById();
      }
    }
  }, [isAuth, formOnlineData]);

  useEffect(() => {
    // ? why are we setting the field (cardDetails) value to the same field value (formik.values?.cardsDetails) ? (it seems that this is a bug)
    formik.setFieldValue("cardsDetails", formik.values?.cardsDetails);

    if (!isAuth) {
      formik.setFieldValue("accountInfo", formik.values?.accountInfo);
    }

    let keysWithoutData = [];
    if (formDataReservation?.length === 0) {
      numberOfTickets.map(ticketId => {
        keysWithoutData.push({ id: ticketId, formData: [], products: [] });
      });
      formik.setFieldValue("registrationForm", keysWithoutData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, numberOfTickets, isAuth]);

  const resetReservation = () => {
    formik.setFieldValue(
      "ticketsData",
      Array.from({ length: numberOfTickets?.length }, () => [...products])
    );
    dispatch(
      formSlice.actions.setVarients(
        JSON.parse(localStorage.getItem("originVarients"))
      )
    );
  };

  const handleLogout = () => {
    formik.setFieldValue("accountInfo", {});
    formik.setFieldValue("activePayment", "credit-card");
    resetReservation();
    localStorage.clear();
    toastr.success("Success", "Successfully Logged out!");
    window.location.href = `/form/${params?.id}`;
  };

  const checkDisabledSubmit = useCallback(() => {
    if (donationError) return true;
    const ticketCount = numberOfTickets?.length || 1;

    // Disable if any onRegistration variant price has no option selected
    const onRegVariantPrices = formOnlineData?.formPricing?.prices?.filter(
      p => p?.type === "onRegistration" && p?.variant
    ) || [];
    const onRegVariantUnselected = onRegVariantPrices.some(price => {
      const variantEntry = Object.values(varients || {}).find(v => v.id === price._id);
      if (!variantEntry) return true;
      const totalSelected = (variantEntry.variantsInfo || []).reduce(
        (sum, v) => sum + (v.counterValue || 0), 0
      );
      return totalSelected === 0;
    });
    if (onRegVariantUnselected) return true;

    return products?.some((product) => {
      if (product?.type !== "optional" || !product?.isRequired) return false;
      if (product?.variant) {
        // Variant required addons: check varients
        const variant = Object.values(varients || {}).find(
          (v) => v.id === product._id,
        );
        if (!variant) return true;
        const totalSelected = (variant.variantsInfo || []).reduce(
          (sum, v) => sum + (v.counterValue || 0),
          0,
        );
        return totalSelected < ticketCount;
      }
      // Non-variant required addons: use counter from ticketsData as source of truth.
      // varients.counterValue is reset by getFormById() after auto-increment fires,
      // but formik.values.ticketsData retains the correct counter value.
      const filledCount = (formik.values.ticketsData || []).filter(
        (ticketProducts) => {
          const p = ticketProducts?.find((tp) => tp._id === product._id);
          return (p?.counter || 0) > 0;
        },
      ).length;
      return filledCount < ticketCount;
    });
  }, [numberOfTickets, products, varients, formik.values.ticketsData, formOnlineData, donationError]);

  const setActivePaymentAfter = useCallback(() => {
    if (!isAuth) return formik.setFieldValue("activePayment", "credit-card");
    const activePayment = formik.values?.activePayment;
    if (
      paymentMethod?.allowMemberInstallment &&
      achPaymentMethod?.allowMemberInstallment
    ) {
      if (activePayment === "bill-my-account") {
        formik.setFieldValue("activePayment", "credit-card");
      }
      return;
    }

    const nextPayment = paymentMethod?.allowMemberInstallment
      ? "credit-card"
      : achPaymentMethod?.allowMemberInstallment
      ? "ach"
      : null;

    if (nextPayment) {
      formik.setFieldValue("activePayment", nextPayment);
    }
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const {
    totalDueAmount,
    dueAmountCF,
    totalDueAmountWithCF,
    dueAmountTotalDiscount
  } = calculateDueAmount();

  return (
    <>
      {formik.values?.resultPage !== "" ? (
        <PaymentResultPage
          result={formik.values?.resultPage}
          formik={formik}
          isTherePayment={totalPay?.total !== "0.00" || totalProducts > 0}
          showThanksMsg={
            formik.values?.activePayment === "bill-my-account" || false
          }
        />
      ) : (
        <>
          <Header
            Logo={logo}
            showTimer={false}
          />
          <Wrapper>
            <Grid
              container
              spacing={2}
              sx={{ width: "100%" }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={!makeFormScreen ? 12 : 7}
                direction="column"
              >
                <Paper
                  sx={{
                    height: isMobile ? "165px" : "227px",
                    borderRadius: "10px",
                    backgroundColor: theme =>
                      theme.palette.mode === "dark" ? "#1A2027" : "#2555EF"
                  }}
                >
                  <ImageContainer isMobile={isMobile}>
                    <CardContent isMobile={isMobile}>
                      <h1>{formOnlineData?.formName}</h1>
                    </CardContent>
                    <div>
                      <ImageCard src={CardImage} alt="bg" isMobile={isMobile} />
                    </div>
                  </ImageContainer>
                </Paper>

                {numberOfTickets?.map((item, index) => (
                  <>
                    <Ticket
                      key={`ticket_${isCheckedApplay}`}
                      index={index}
                      formik={formik}
                      ticketUniqueId={item}
                      setIsCheckedApplay={setIsCheckedApplay}
                      isCheckedApplay={isCheckedApplay}
                      totalProducts={totalProducts}
                      handleTotalForPay={handleTotalForPay}
                    />
                    <br />
                  </>
                ))}
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={5} direction="column">
                <SummaryCard
                  handleTotalForPay={handleTotalForPay}
                  totalPaymentWithCVFee={totalPaymentWithCVFee}
                  formik={formik}
                  billMyAccount={
                    formik?.values?.activePayment === "bill-my-account"
                  }
                  setTicketInstallment={setTicketInstallment}
                  ticketInstallment={ticketInstallment}
                  newProducts={newProducts}
                  setProducts={setProducts}
                  dueAmountCF={dueAmountCF}
                  totalDueAmountWithCF={totalDueAmountWithCF}
                  totalDiscount={totalDiscount}
                  dueAmountTotalDiscount={dueAmountTotalDiscount}
                  totalDueAmount={totalDueAmount}
                  isInstallmentEnabled={isInstallmentEnabled}
                  setActivePaymentAfter={setActivePaymentAfter}
                  activePayment={activePayment}
                  convenienceFeeByPayment={convenienceFeeByPayment}
                  setConvenienceFeeByPayment={setConvenienceFeeByPayment}
                  currentPaymentMethod={currentPaymentMethod}
                  onCalcDueAmountChange={setCalcDueAmount}
                  donationAmount={donationAmount}
                />

                <PersonalDetailsCard
                  formik={formik}
                  isLoadingPay={isLoadingPay}
                  PayNow={PayNow}
                  error={error}
                  setError={setError}
                  handleTotalForPay={handleTotalForPay}
                  totalProducts={totalProducts}
                  isTherePayment={makeFormScreen}
                  showZipCode={!isAuth}
                  isAuthenticated={isAuth}
                  handleLogout={handleLogout}
                  logout={logout}
                  onOpenLoginModal={() => setLoginModalOpen(true)}
                />
                <LoginModal
                  open={loginModalOpen}
                  onClose={() => setLoginModalOpen(false)}
                  onSuccess={(accountInfo) => {
                    setLoginModalOpen(false);
                    setAuthTick((t) => t + 1);
                    if (accountInfo?.first_name) {
                      formik.setFieldValue("accountInfo.first_name", accountInfo.first_name);
                      formik.setFieldValue("accountInfo.last_name", accountInfo.last_name);
                      formik.setFieldValue("accountInfo.primary_email_address", accountInfo.primary_email_address);
                    }
                  }}
                />

                {formik?.values?.activePayment !== "bill-my-account" && (
                  <DonationBox
                    ledger={checkoutDonationLedger}
                    loading={isLoadingDonationLedger}
                    onDonationChange={(amount, ledger) => { setDonationAmount(amount); if (ledger) setCheckoutDonationLedger(ledger); }}
                    onErrorChange={setDonationError}
                  />
                )}

                <PaymentCard
                  TotalForPay={totalProducts}
                  formik={formik}
                  setError={setError}
                  error={error}
                  PayNow={PayNow}
                  isLoadingPay={isLoadingPay}
                  handleTotalForPay={handleTotalForPay}
                  setLoadingPay={setLoadingPay}
                  isStripe={isStripe}
                  isTranzila={isTranzila}
                  currentPaymentMethod={currentPaymentMethod}
                  addCardStripeRef={addCardStripeRef}
                  isAuthenticated={isAuth}
                  setSelectedCard={setSelectedCard}
                  selectedCard={selectedCard}
                  totalDueAmountWithCF={calcDueAmount !== null ? calcDueAmount : totalDueAmountWithCF}
                  recaptchaRef={recaptchaRef}
                  setSelectedAchCard={setSelectedAchCard}
                  selectedAchCard={selectedAchCard}
                  enableCreditCardPay={enableCreditCardPay}
                  enableAchPay={enableAchPay}
                  disabledAchPay={disabledAchPay}
                  displayAchTooltip={displayAchTooltip}
                  disabledCreditCardPay={disabledCreditCardPay}
                  disabledBillMyAccount={disabledBillMyAccount}
                  enableBillMyAccount={enableBillMyAccount}
                  publicKey={
                    currentPaymentMethod?.paymentGateway?.keys?.publicKey
                  }
                  checkDisabledSubmit={checkDisabledSubmit}
                  onTranzilaCharged={handleTranzilaCharged}
                  orgId={localStorage.getItem("formOrgId")}
                  isRegistrationReady={isRegistrationFormValid}
                />
              </Grid>
            </Grid>

            <ContactUs formOnlineData={formOnlineData} />
          </Wrapper>
          {handleTotalForPay()?.total === "0.00" && totalProducts <= 0 && (
            <Grid item xs={12}>
              <PaymentButtonSubmit isDisabled={thereIsFormEmpty}>
                <button
                  disabled={thereIsFormEmpty}
                  onClick={() => {
                    if (
                      sharedFunctions.filterObjectsWithPriceKey(
                        formik.values?.registrationForm[0]?.products
                      )
                    ) {
                      enqueueSnackbar(
                        "Please assign amount for all products you chose",
                        {
                          variant: "error"
                        }
                      );
                    } else {
                      const prices =
                        formOnlineData?.formPricing?.prices || [];
                      const checkedOpenAmounts = Object.values(
                        varients || {}
                      ).filter(
                        v =>
                          v?.type === "openAmount" &&
                          (v?.counterValue || 0) > 0
                      );
                      let openAmountError = null;
                      for (const v of checkedOpenAmounts) {
                        const priceInfo = prices.find(p => p._id === v.id);
                        const minimum = priceInfo?.minimumOpenAmount || 0;
                        const entered = v?.price;
                        if (
                          entered === undefined ||
                          entered === null ||
                          entered === "" ||
                          entered === 0
                        ) {
                          openAmountError = `"${v.varientTitle}" open amount field is empty`;
                          break;
                        }
                        if (minimum > 0 && Number(entered) < minimum) {
                          openAmountError = `"${v.varientTitle}" amount must be at least $${minimum}`;
                          break;
                        }
                      }
                      if (openAmountError) {
                        enqueueSnackbar(openAmountError, {
                          variant: "error"
                        });
                      } else {
                        PayNow();
                      }
                    }
                  }}
                >
                  {isLoadingPay ? (
                    <ClipLoader
                      color={"#ffffff"}
                      loading={isLoadingPay}
                      size={32}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  ) : (
                    "Submit"
                  )}
                </button>
              </PaymentButtonSubmit>
            </Grid>
          )}
        </>
      )}
    </>
  );
};
